// extracted by mini-css-extract-plugin
export var banner = "_h8-0";
export var closeButton = "_h8-2";
export var greenCheckmark = "_h8-3";
export var hereLink = "_h8-4";
export var titleIcon = "_h8-1";